import {
  CommonPageWrapper,
  CustomgridLayoutWrapper,
  HeadingWrapper,
} from 'admin/components/wrappers';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import BackButton from 'app/components/BackButton';
import styled from 'styled-components';
import AdminCustomButton from 'app/components/AdminCustomButton';
import SimpleReactValidator from 'simple-react-validator';
import React, { useMemo, useRef, useState } from 'react';
import { GeneralLookup, RiderClass } from 'services/openapi';
import useUserApi from 'admin/hooks/useUserApi';
import { useParams } from 'react-router-dom';
import { CommonLoader } from 'app/components/CommonLoader';
import { findObjectById, getLookupArray, isEmptyArray } from 'utils/common';
import useCommonLookUpDatas from 'hooks/useCommonLookupData';
import { ShowRiderWrapper, defaulShowstRiderValue } from './staticDefaultData';
import { GridLayoutItem } from '@progress/kendo-react-layout';
import { GridPageChangeEvent } from '@progress/kendo-react-grid';
import AdminDropDown from 'app/components/AdminDropDown';
import { defaultLookup } from 'admin/pages/RiderIndividual/components/RiderCreatePage/staticDatas';
import useShowApi from 'admin/hooks/useShowApi';
import CustomDataGrid from 'app/components/CustomDataGrid/Index';
import RiderClassUpdateCell from 'app/components/CustomDataGrid/Cells/RiderClassUpdateCell';
import { TitleCardWrapper } from 'admin/pages/ShowsPage/ShowResultPage/ScoreBoardPage';
import { AdminCheckBox } from 'app/components/AdminCheckbox';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import NoDataFound from 'app/components/NoDataFound';
import Cookies from 'js-cookie';

export const CreateShowsRider = () => {
  const userType = Cookies.get('userType') ?? '';
  const {
    SaveRiderInShow,
    GetRiderListShows,
    showRiderList,
    setShowRiderList,
    loading: showRiderLoading,
  } = useShowApi();
  const [riderClass, setRiderClass] = useState<Array<RiderClass>>([]);
  const simpleValidator = useRef(new SimpleReactValidator());
  const { action, id: showId, showName } = useParams();
  const showLookup = useMemo(() => {
    let showLookup: GeneralLookup = {
      id: showId ?? '',
      name: 'show',
      code: null,
      children: null,
      otherName: null,
      isAdminLive: null,
    };
    return showLookup;
  }, [showId]);
  const { getUserProfileViewData, loading } = useUserApi();
  const [teamId, setTeamId] = useState<GeneralLookup>();
  const [catagoryId, setCatagoryId] = useState<GeneralLookup>();
  const [divisionId, setDivisionId] = useState<GeneralLookup>();

  const [, setCategoryListFromTeam] = React.useState<Array<GeneralLookup>>([]);
  const [divisionOneList, setDivisionOnelist] = React.useState<
    Array<GeneralLookup>
  >([]);
  const [, setIsCategoryNotInTeam] = useState(false);
  const [showsRiderData, setShowsRiderData] = React.useState<ShowRiderWrapper>(
    defaulShowstRiderValue,
  );
  const [forceUpdate, setForceUpdate] = useState(false);
  const { getAllLookupData, lookUps } = useCommonLookUpDatas();
  const breadCrumpitemsUser = [
    {
      id: '',
      text: userType === 'COACH' ? 'Showyeda coach' : 'Showyeda admin',
      disabled: true,
    },
    {
      id: userType === 'COACH' ? '/coach/shows' : '/admin/shows',
      text: 'Shows',
    },
    {
      id: 'navigateBack',
      text: 'Shows Info',
    },
    {
      id: '',
      text: 'Add Rider',
      disabled: true,
    },
  ];
  const clearRiderData = () => {
    setShowRiderList([]);
    setRiderClass(prevState => {
      const currentState = prevState || [];
      return currentState.map(riderEntry => ({
        ...riderEntry,
        classList: [], // Reset classList to an empty array
      }));
    });
    setClassAChecked(prevState => {
      const newState = {};
      Object.keys(prevState).forEach(riderId => {
        newState[riderId] = false; // Set each rider's checkbox to false
      });
      return newState;
    });
    setClassBChecked(prevState => {
      const newState = {};
      Object.keys(prevState).forEach(riderId => {
        newState[riderId] = false; // Set each rider's checkbox to false
      });
      return newState;
    });
    setClassASplitNumber(prevState => {
      const newState = {};
      Object.keys(prevState).forEach(riderId => {
        newState[riderId] = false; // Set each rider's checkbox to false
      });
      return newState;
    });
    setClassBSplitNumber(prevState => {
      const newState = {};
      Object.keys(prevState).forEach(riderId => {
        newState[riderId] = false; // Set each rider's checkbox to false
      });
      return newState;
    });
    // Clear rider selection states
    setSelectedRiders({});
    setAllRidersSelected(false);
  };
  const [allRidersSelected, setAllRidersSelected] = useState(false);
  const [showSelectedOnly, setShowSelectedOnly] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRiders, setSelectedRiders] = useState<Record<string, boolean>>(
    {},
  );

  const filterRiders = (riders: any[]) => {
    if (!riders) return [];
    return riders.filter(rider => {
      const searchLower = searchQuery.toLowerCase();
      return (
        !searchQuery ||
        (rider.rider && rider.rider.toLowerCase().includes(searchLower)) ||
        (rider.backNumber &&
          rider.backNumber.toLowerCase().includes(searchLower)) ||
        (rider.team && rider.team.toLowerCase().includes(searchLower))
      );
    });
  };
  const handleRiderSelection = (e, isChecked) => {
    console.log(e, 'handleRiderSelection');
    const riderId = e.dataItem.id;
    const riderName = e.dataItem.rider;
    const riderTeamId = e.dataItem?.teamInfo?.id;
    const riderTeam = e.dataItem?.teamInfo?.name;

    // Find rider data once
    const riderData = showRiderList
      .flatMap(category => category.riders ?? [])
      .find(rider => rider.id === riderId);

    // Define the updates type
    interface Updates {
      selectedRiders: Record<string, boolean>;
      classAChecked: { [key: string]: boolean };
      riderClassList: Array<RiderClass>;
      allRidersSelected?: boolean;
    }

    // Batch all state updates
    const updates: Updates = {
      selectedRiders: { ...selectedRiders, [riderId]: isChecked },
      classAChecked: { ...classAChecked },
      riderClassList: [...(riderClass || [])],
    };

    if (!isChecked) {
      // Handle deselection
      updates.allRidersSelected = false;

      // Uncheck classes in bulk
      if (riderData?.class) {
        riderData.class.forEach(classItem => {
          const compositeKey = `${riderId}_${classItem.riderClass?.id}`;
          updates.classAChecked[compositeKey] = false;
        });
      }

      // Remove from rider class array
      updates.riderClassList = updates.riderClassList.filter(
        entry => entry?.rider?.id !== riderId,
      );
    } else {
      // Handle selection
      updates.allRidersSelected = Object.entries(updates.selectedRiders).every(
        ([id, selected]) => selected || id === riderId,
      );

      // Add rider to class list if not already present
      if (!updates.riderClassList.some(entry => entry?.rider?.id === riderId)) {
        const category = showRiderList.find(cat =>
          cat.riders?.some(r => r.id === riderId),
        )?.category || {
          id: '',
          name: '',
          code: null,
          children: null,
          otherName: null,
          isAdminLive: null,
        };

        // Auto-populate classList with all available classes for this rider
        const classList =
          riderData?.class?.map(classItem => ({
            class: classItem.riderClass,
            splitNumber: classItem.split?.name || null,
          })) || [];

        // Add new rider entry with auto-populated classList
        updates.riderClassList.push({
          rider: { id: riderId, name: riderName },
          team: { id: riderTeamId ?? teamId?.id, name: riderTeam },
          category,
          classList, // Auto-populate with all available classes
        });
      }

      // Auto-check all class checkboxes for this rider
      if (riderData?.class) {
        riderData.class.forEach(classItem => {
          const compositeKey = `${riderId}_${classItem.riderClass?.id}`;
          updates.classAChecked[compositeKey] = true;
        });
      }
    }

    // Apply all state updates at once
    setSelectedRiders(updates.selectedRiders);
    setAllRidersSelected(updates.allRidersSelected);
    setClassAChecked(updates.classAChecked);
    setRiderClass(updates.riderClassList);
  };

  const handleSelectAllRidersInCategory = (item, isChecked) => {
    const newSelectedRiders = { ...selectedRiders };
    let newRiderClassArray = [...riderClass];

    // Only process riders in this specific category
    item.riders?.forEach(rider => {
      if (rider.id) {
        newSelectedRiders[rider.id] = isChecked;

        // Update class checkboxes for this rider
        if (rider.class && rider.class.length > 0) {
          rider.class.forEach(classItem => {
            const compositeKey = `${rider.id}_${classItem.riderClass?.id}`;
            setClassAChecked(prev => ({
              ...prev,
              [compositeKey]: isChecked,
            }));
          });
        }

        if (isChecked) {
          // Add rider to riderClass array if not already present
          const classList =
            rider.class && rider.class.length > 0
              ? rider.class.map(classItem => ({
                  class: classItem.riderClass,
                  splitNumber: classItem.split?.name || null,
                }))
              : [];

          const alreadyExists = newRiderClassArray.some(
            r => r?.rider?.id === rider.id,
          );

          if (!alreadyExists) {
            newRiderClassArray.push({
              rider: { id: rider.id, name: rider.rider },
              team: { id: rider.teamInfo?.id ?? teamId?.id, name: rider.team },
              category: item.category as GeneralLookup,
              classList: classList,
            });
          }
        } else {
          // Remove rider from riderClass array if deselecting
          newRiderClassArray = newRiderClassArray.filter(
            r => r?.rider?.id !== rider.id,
          );
        }
      }
    });

    setSelectedRiders(newSelectedRiders);
    setRiderClass(newRiderClassArray);
  };
  // Fixed handleSaveClick function
  const handleSaveClick = () => {
    const isValid = simpleValidator.current.allValid();
    if (isValid) {
      // Get only riders that are selected
      const selectedRiderIds = Object.keys(selectedRiders).filter(
        id => selectedRiders[id],
      );

      // Filter the riderClass array to only include selected riders
      const formattedRiders = riderClass?.filter(rider =>
        selectedRiderIds.includes(rider?.rider?.id ?? ''),
      );

      const payload = {
        show: showLookup,
        riders: formattedRiders || [],
      };

      SaveRiderInShow(payload, showId);
    } else {
      simpleValidator.current.showMessages();
      setForceUpdate(!forceUpdate);
    }
  };

  const onDataChangeTeam = e => {
    // Handle clear selection
    if (e.id === 'clear') {
      setShowsRiderData({
        ...showsRiderData,
        team: defaultLookup,
        category: defaultLookup,
        divisionClassOne: defaultLookup,
      });
      setTeamId(undefined);
      setCatagoryId(undefined);
      setDivisionId(undefined);
      clearRiderData();
      setCategoryListFromTeam([]);
      setDivisionOnelist([]);
      setIsCategoryNotInTeam(false);
      return;
    }

    setShowsRiderData({
      ...showsRiderData,
      team: e,
      category: defaultLookup,
      divisionClassOne: defaultLookup,
    });
    GetRiderListShows(showId, e.id);
    setTeamId(e);
    clearRiderData();
    let teamLookUpList = getLookupArray('ACTIVETEAM', lookUps);
    const matchingObject = findObjectById(teamLookUpList, e.id);
    if (matchingObject) {
      const { children } = matchingObject;
      setCategoryListFromTeam(children!);
      setDivisionOnelist([]);
    }
    setIsCategoryNotInTeam(e.children.length === 0 ? true : false);
    const arrays = ['Category', `Division/Classes One`, `Division/Classes Two`];
    e.children.length === 0 &&
      arrays.forEach(field => {
        simpleValidator.current.hideMessageFor(field);
        simpleValidator.current.visibleFields = [];
        setForceUpdate(prevState => !prevState);
      });
  };
  const onDataChangeCategory = e => {
    // Handle clear selection
    if (e.id === 'clear') {
      setShowsRiderData({
        ...showsRiderData,
        category: defaultLookup,
        divisionClassOne: defaultLookup,
      });
      setCatagoryId(undefined);
      setDivisionId(undefined);
      clearRiderData();
      setDivisionOnelist([]);
      GetRiderListShows(showId, teamId?.id, undefined);
      return;
    }

    setShowsRiderData({
      ...showsRiderData,
      category: e,
      divisionClassOne: defaultLookup,
      rider: defaultLookup,
    });
    GetRiderListShows(showId, teamId?.id, e.id);
    setCatagoryId(e);
    clearRiderData();
    let categoryLookUpList = getLookupArray('CATEGORY', lookUps);
    const matchingObject = findObjectById(categoryLookUpList, e.id);
    if (matchingObject) {
      const { children } = matchingObject;
      setDivisionOnelist(children!);
    }
  };

  const onDataChangeDivisionOne = e => {
    // Handle clear selection
    if (e.id === 'clear') {
      setShowsRiderData({
        ...showsRiderData,
        divisionClassOne: defaultLookup,
      });
      setDivisionId(undefined);
      clearRiderData();
      GetRiderListShows(showId, teamId?.id, catagoryId?.id, undefined);
      return;
    }

    GetRiderListShows(showId, teamId?.id, catagoryId?.id, e.id);
    setShowsRiderData({
      ...showsRiderData,
      divisionClassOne: e,
    });
    setDivisionId(e);
    clearRiderData();
  };

  const handleCancelClick = () => {
    setShowsRiderData(defaulShowstRiderValue);
    setCategoryListFromTeam([]);
    setDivisionOnelist([]);
    setIsCategoryNotInTeam(false);
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    setForceUpdate(prevState => !prevState);
    clearRiderData();
  };

  React.useEffect(() => {
    if (action === 'update') {
      getUserProfileViewData(showId ?? '');
    }
  }, [showId, action]);

  React.useEffect(() => {
    getAllLookupData('CATEGORY,DIVISION,ACTIVETEAM');
  }, []);

  const [classASplitNumber, setClassASplitNumber] = React.useState<{
    [key: string]: GeneralLookup;
  }>({});

  const [classBSplitNumber, setClassBSplitNumber] = React.useState<{
    [key: string]: GeneralLookup;
  }>({});
  const [classAChecked, setClassAChecked] = React.useState<{
    [key: string]: boolean;
  }>({});
  const [classBChecked, setClassBChecked] = React.useState<{
    [key: string]: boolean;
  }>({});

  const onClassAChange = (e, event, riderClass) => {
    const riderId = e.dataItem.id;
    const classId = riderClass.id;
    const isChecked = event.value;

    setRiderClass(prevState => {
      const currentState = prevState || [];
      let riderFound = false;

      const updatedState = currentState.map(riderEntry => {
        if (riderEntry?.rider?.id === riderId) {
          riderFound = true;
          // Create a new classList array or use the existing one
          const classList = riderEntry.classList || [];

          // Find index of existing class if any
          const classIndex = classList.findIndex(
            item => item.class?.id === classId,
          );

          // Create updated classList
          const updatedClassList = [...classList];

          if (classIndex >= 0) {
            // Update existing class entry if checked
            if (isChecked) {
              // Keep existing entry
              updatedClassList[classIndex] = {
                ...updatedClassList[classIndex],
              };
            } else {
              // Remove the class if unchecked
              updatedClassList.splice(classIndex, 1);
            }
          } else if (isChecked) {
            // Add new class entry if checked and doesn't exist
            updatedClassList.push({
              class: riderClass, // Use the complete riderClass object
              splitNumber: null,
            });
          }

          return {
            ...riderEntry,
            classList: updatedClassList,
          };
        }
        return riderEntry;
      });

      // If rider was not found, add them to the list (shouldn't happen but safety check)
      if (!riderFound && isChecked) {
        const category = showRiderList.find(cat =>
          cat.riders?.some(r => r.id === riderId),
        )?.category || {
          id: '',
          name: '',
          code: null,
          children: null,
          otherName: null,
          isAdminLive: null,
        };

        const riderData = showRiderList
          .flatMap(category => category.riders ?? [])
          .find(rider => rider.id === riderId);

        updatedState.push({
          rider: { id: riderId, name: riderData?.rider || '' },
          team: {
            id: riderData?.teamInfo?.id ?? teamId?.id ?? '',
            name: riderData?.team || '',
          },
          category,
          classList: [
            {
              class: riderClass,
              splitNumber: null,
            },
          ],
        });
      }

      return updatedState;
    });
  };

  const onClassASplitNumberDataChange = (e, event, riderClass) => {
    const riderId = e.dataItem.id;
    const classId = riderClass.id;
    const splitNumber = event.name || event.id;

    setRiderClass(prevState => {
      const currentState = prevState || [];
      return currentState.map(riderEntry => {
        if (riderEntry?.rider?.id === riderId) {
          // Create a new classList array or use the existing one
          const classList = riderEntry.classList || [];

          // Find index of existing class if any
          const classIndex = classList.findIndex(
            item => item.class?.id === classId,
          );

          // Create updated classList
          const updatedClassList = [...classList];

          if (classIndex >= 0) {
            // Update existing class entry
            updatedClassList[classIndex] = {
              ...updatedClassList[classIndex],
              splitNumber,
            };
          } else {
            // Add new class entry
            updatedClassList.push({
              class: riderClass, // Use the complete riderClass object
              splitNumber,
            });
          }

          return {
            ...riderEntry,
            classList: updatedClassList,
          };
        }
        return riderEntry;
      });
    });
  };

  React.useEffect(() => {
    if (showRiderList?.length > 0) {
      // Initialize checkbox and split number states
      const initialClassAChecked = {};
      const initialClassBChecked = {};
      const initialClassASplitNumber = {};
      const initialClassBSplitNumber = {};
      const initialSelectedRiders = {};

      // Initialize rider class array
      const initialRiderClass: Array<RiderClass> = [];

      // Store teamId locally to avoid dependency issues
      // Using teamId?.id directly

      showRiderList.forEach(category => {
        category.riders?.forEach(rider => {
          // Create rider entry
          const riderEntry: RiderClass = {
            rider: { id: rider.id as string, name: rider.rider as string },
            team: {
              id: rider?.teamInfo?.id ?? teamId?.id ?? '',
              name: rider.team as string,
            },
            category: category.category,
            classList: [],
          };

          // Don't automatically select any classes - removed hasSelectedClass variable

          // Initialize class data structures without checking them
          if (rider.class && rider.class.length > 0) {
            rider.class.forEach(classItem => {
              // Use composite key for each class
              const compositeKey = `${rider.id}_${classItem?.riderClass?.id}`;

              // Don't check boxes automatically - removed setting initialClassAChecked to true

              // Just prepare the data structure
              if (classItem.split) {
                initialClassASplitNumber[compositeKey] = {
                  id: classItem.split,
                  name: classItem.split,
                };
              }
            });
          }

          // Don't auto-select riders either
          if (rider.id) {
            initialSelectedRiders[rider.id] = false; // Set all to false initially
          }

          initialRiderClass.push(riderEntry);
        });
      });

      // All riders start as not selected
      setAllRidersSelected(false);

      setRiderClass(initialRiderClass);
      setClassAChecked(initialClassAChecked);
      setClassBChecked(initialClassBChecked);
      setClassASplitNumber(initialClassASplitNumber);
      setClassBSplitNumber(initialClassBSplitNumber);
      setSelectedRiders(initialSelectedRiders);
    }
  }, [showRiderList, teamId?.id]);

  // Sync classAChecked state to riderClass classList
  React.useEffect(() => {
    if (Object.keys(classAChecked).length > 0) {
      setRiderClass(prevState => {
        const updatedState: RiderClass[] = prevState.map(riderEntry => {
          const rider = riderEntry.rider;
          // Get all checked classes for this rider
          const checkedClasses = Object.entries(classAChecked)
            .filter(([key, isChecked]) => {
              return isChecked && key.startsWith(rider?.id + '_');
            })
            .map(([key]) => {
              // Extract classId from composite key (riderId_classId)
              const classId = key.split('_')[1];
              // Find the class object from showRiderList
              const riderData = showRiderList
                .flatMap(cat => cat.riders ?? [])
                .find(r => r.id === rider?.id);

              if (riderData?.class) {
                const classItem = riderData.class.find(
                  c => c.riderClass?.id === classId,
                );
                if (classItem) {
                  return {
                    class: classItem.riderClass,
                    splitNumber: classASplitNumber[key]?.name || null,
                  };
                }
              }
              return null;
            })
            .filter((item): item is NonNullable<typeof item> => item !== null);

          // Only update if classList changed
          const classListChanged =
            checkedClasses.length !== riderEntry?.classList?.length ||
            checkedClasses.some(
              (newClass, idx) =>
                newClass?.class?.id !== riderEntry?.classList?.[idx]?.class?.id,
            );

          if (classListChanged) {
            return {
              ...riderEntry,
              classList: checkedClasses as any,
            };
          }

          return riderEntry;
        });

        return updatedState;
      });
    }
  }, [classAChecked, classASplitNumber, showRiderList]);

  return (
    <>
      <StyledCommonPageWrapper>
        {loading && <CommonLoader loaderType="main" />}
        <StyledHeadingWrapper>
          <StyledPageMainLabel title={showName}>
            Add Rider - ({showName})
          </StyledPageMainLabel>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              justifyContent: 'end',
            }}
          >
            <SearchWrapper>
              <div className="search-box">
                <input
                  type="text"
                  placeholder="Search by rider name, back number, or team..."
                  value={searchQuery}
                  onChange={e => setSearchQuery(e.target.value)}
                  className="search-input"
                />
              </div>
            </SearchWrapper>
            <CustomBreadCrumb preData={breadCrumpitemsUser} />
          </div>
        </StyledHeadingWrapper>
        <ContentWrapper>
          <BtnWrapper>
            <div>
              <BackButton isNavHistory />
            </div>
            <div className="btn-action">
              <AdminCustomButton
                buttonType="cancel"
                onClick={handleCancelClick}
              >
                Clear
              </AdminCustomButton>
              <AdminCustomButton
                buttonType="save"
                onClick={handleSaveClick}
                disabled={
                  // No riders selected
                  Object.keys(selectedRiders).length === 0 ||
                  // All riders are unselected
                  Object.values(selectedRiders).every(
                    selected => selected === false,
                  ) ||
                  // At least one selected rider has no classes selected
                  Object.entries(selectedRiders).some(
                    ([riderId, isSelected]) => {
                      if (isSelected) {
                        // Check if there's at least one class checked for this rider
                        const hasClassChecked = Object.entries(
                          classAChecked,
                        ).some(([classKey, isChecked]) => {
                          // Check if the composite key starts with this rider's ID and is checked
                          return (
                            classKey.startsWith(riderId + '_') && isChecked
                          );
                        });
                        // Return true (to disable button) if no classes are checked for this rider
                        return !hasClassChecked;
                      }
                      return false;
                    },
                  )
                }
              >
                Save
              </AdminCustomButton>
            </div>
          </BtnWrapper>
          <GridWrapper>
            <CustomgridLayoutWrapper
              className="custom-grid-wrapper"
              rows={[{ height: 'auto' }]}
              cols={[
                { width: 'calc(33.33% - 7px)' },
                { width: 'calc(33.33% - 7px)' },
                { width: 'calc(33.33% - 7px)' },
              ]}
              gap={{ rows: 20, cols: 10 }}
              style={{ paddingTop: '20px' }}
            >
              <GridLayoutItem className="team-style">
                <AdminDropDown
                  label="Team "
                  placeholder=""
                  data={[
                    {
                      id: 'clear',
                      name: '-- Clear Selection --',
                      code: null,
                      children: null,
                      otherName: null,
                      isAdminLive: null,
                    },
                    ...getLookupArray('ACTIVETEAM', lookUps),
                  ]}
                  onDataChange={onDataChangeTeam}
                  defaultValue={showsRiderData?.team ?? ''}
                  className="field-style"
                  isLoader={loading}
                  // validations="required"
                />
                {/* {isCategoryNotInTeam && (
                  <span className="error-msg">
                    Selected team is not available, choose another team
                  </span>
                )} */}
              </GridLayoutItem>
              <GridLayoutItem>
                <AdminDropDown
                  label="Category "
                  placeholder=""
                  data={[
                    {
                      id: 'clear',
                      name: '-- Clear Selection --',
                      code: null,
                      children: null,
                      otherName: null,
                      isAdminLive: null,
                    },
                    ...getLookupArray('CATEGORY', lookUps),
                  ]}
                  onDataChange={onDataChangeCategory}
                  defaultValue={showsRiderData?.category}
                  className="field-style"
                  // disabled={isEmptyArray(categoryListFromTeam)}
                  isLoader={loading}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <AdminDropDown
                  label="Division"
                  placeholder=""
                  data={[
                    {
                      id: 'clear',
                      name: '-- Clear Selection --',
                      code: null,
                      children: null,
                      otherName: null,
                      isAdminLive: null,
                    },
                    ...getLookupArray('DIVISION', lookUps),
                  ]}
                  onDataChange={onDataChangeDivisionOne}
                  defaultValue={showsRiderData?.divisionClassOne! ?? undefined}
                  className="field-style"
                  // disabled={isEmptyArray(divisionOneList)}
                  isLoader={loading}
                />
              </GridLayoutItem>
            </CustomgridLayoutWrapper>
          </GridWrapper>
        </ContentWrapper>
        <>
          {/* Only show filter when there are selected riders */}
          {Object.values(selectedRiders).some(
            selected => selected === true,
          ) && (
            <FilterWrapper>
              <div className="filter-controls">
                <AdminCheckBox
                  onChange={event => setShowSelectedOnly(event.value)}
                  value={showSelectedOnly}
                  label="Show Selected Only Riders"
                  className="show-selected-checkbox"
                  title="Show only the riders that are currently selected"
                />
              </div>
            </FilterWrapper>
          )}

          <TableWrapper>
            {showRiderLoading ? (
              <TableSkeletonLoader
                rowContent={8}
                width={100}
                headingWidth={80}
              />
            ) : (
              <>
                {showRiderList?.length === 0 && <NoDataFound />}
                {Array.isArray(showRiderList) ? (
                  showRiderList.map((item, index) => {
                    // Filter riders based on showSelectedOnly checkbox
                    const filteredRiders = showSelectedOnly
                      ? (item.riders ?? []).filter(rider =>
                          rider.id ? selectedRiders[rider.id] === true : false,
                        )
                      : item.riders ?? [];

                    // Only show category section if it has riders to display
                    if (
                      filteredRiders.length === 0 ||
                      filterRiders === undefined
                    ) {
                      return null;
                    }

                    const categoryKey = `${item.category?.id}_${index}`;
                    const filteredAndSearchedRiders =
                      filterRiders(filteredRiders);
                    const areAllRidersInCategorySelected =
                      item.riders?.every(rider =>
                        rider.id ? selectedRiders[rider.id] === true : false,
                      ) || false;
                    const RiderColumn = [
                      {
                        field: 'select',
                        headerCell: () => (
                          <AdminCheckBox
                            onChange={event =>
                              handleSelectAllRidersInCategory(item, event.value)
                            }
                            value={areAllRidersInCategorySelected}
                            label=""
                            className="checkbox-style"
                            title="Select All Riders"
                          />
                        ),
                        cell: e => (
                          <td>
                            <AdminCheckBox
                              onChange={event =>
                                handleRiderSelection(e, event.value)
                              }
                              value={selectedRiders[e.dataItem.id] || false}
                              label=""
                              title={`Select ${e.dataItem.rider}`}
                            />
                          </td>
                        ),
                        width: '60',
                      },
                      {
                        field: 'team',
                        title: 'Team',
                      },
                      {
                        field: 'rider',
                        title: 'Rider Name',
                        width: '200',
                      },
                      {
                        field: 'backNumber',
                        title: 'Back Number',
                        width: '100',
                      },
                      // {
                      //   field: 'height',
                      //   title: 'Height',
                      //   width: '100',
                      // },
                      // {
                      //   field: 'weight',
                      //   title: 'Weight',
                      //   width: '100',
                      // },
                      {
                        field: 'grade',
                        title: 'Grade',
                        width: '100',
                      },
                      {
                        field: 'state',
                        title: 'State',
                        width: '150',
                      },
                      {
                        field: '',
                        title: 'Class',
                        cell: e => (
                          <RiderClassUpdateCell
                            e={e}
                            classASplitNumber={classASplitNumber}
                            setClassASplitNumber={setClassASplitNumber}
                            classBSplitNumber={classBSplitNumber}
                            setClassBSplitNumber={setClassBSplitNumber}
                            onClassASplitNumberDataChange={
                              onClassASplitNumberDataChange
                            }
                            onClassAChange={onClassAChange}
                            classAChecked={classAChecked}
                            setClassAChecked={setClassAChecked}
                            classBChecked={classBChecked}
                            setClassBChecked={setClassBChecked}
                            isRiderSelected={
                              selectedRiders[e.dataItem.id] || false
                            }
                          />
                        ),
                        width: '400',
                      },
                    ];
                    return (
                      <CategorySection key={categoryKey}>
                        <TitleCardWrapper>
                          <HeadingWrapper className="heading-wrapper">
                            <PageMainLabel className="label-wrapper">
                              {item?.category?.name} {item?.division?.name}
                              <RiderCount>
                                ({filteredAndSearchedRiders.length} riders)
                              </RiderCount>
                            </PageMainLabel>
                          </HeadingWrapper>
                        </TitleCardWrapper>
                        <CustomDataGrid
                          data={filteredAndSearchedRiders}
                          columns={RiderColumn}
                          pageSize={filteredAndSearchedRiders.length || 50}
                          skip={0}
                          totalCount={filteredAndSearchedRiders.length}
                          key={`${categoryKey}_grid`}
                          loader={showRiderLoading}
                          showPagination={false}
                          rowRender={(row, props) => {
                            const isSelected =
                              selectedRiders[props.dataItem.id] || false;
                            return (
                              <tr
                                {...props}
                                style={{
                                  ...props.style,
                                  backgroundColor: props.dataItem.isTryIt
                                    ? '#f9de91'
                                    : isSelected
                                    ? '#fffbf0'
                                    : 'transparent',
                                  color: props.dataItem.isTryIt
                                    ? 'red'
                                    : 'inherit',
                                }}
                              >
                                {props.children}
                              </tr>
                            );
                          }}
                        />
                      </CategorySection>
                    );
                  })
                ) : (
                  <NoDataFound />
                )}
              </>
            )}
          </TableWrapper>
        </>
      </StyledCommonPageWrapper>
    </>
  );
};
const TableWrapper = styled.div`
  height: calc(60vh - 10px);
  overflow: auto;
`;
const FilterWrapper = styled.div`
  padding: 15px 5px;
  border-bottom: 1px solid #eaecf0;
  background-color: #f8f9fa;

  .filter-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }

  .show-selected-checkbox {
    margin-bottom: 0;
    label {
      font-weight: 500;
      color: #495057;
    }
  }

  .search-box {
    flex: 1;
    max-width: 400px;

    .search-input {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #ced4da;
      border-radius: 4px;
      font-size: 14px;

      &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
      }

      &::placeholder {
        color: #6c757d;
      }
    }
  }
`;
const SearchWrapper = styled.div`
  padding: 15px 5px;
  .show-selected-checkbox {
    margin-bottom: 0;
    label {
      font-weight: 500;
      color: #495057;
    }
  }

  .search-box {
    flex: 1;
    max-width: 400px;
    min-width: 350px;

    .search-input {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #ced4da;
      border-radius: 4px;
      font-size: 14px;

      &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
      }

      &::placeholder {
        color: #6c757d;
      }
    }
  }
`;

const CategorySection = styled.div`
  margin-bottom: 20px;
`;

const RiderCount = styled.span`
  color: #666;
  font-size: 14px;
  margin-left: 8px;
  font-weight: normal;
`;

const StyledCommonPageWrapper = styled(CommonPageWrapper)`
  .k-grid {
    margin-bottom: 40px;
    .checkbox-style {
      margin-bottom: 0;
    }
  }
  .SplitWrapper {
    width: 100% !important;
    .SHdropdown {
      width: fit-content;
      .k-dropdownlist {
        @media (min-width: 500px) and (max-width: 991px) {
          width: 150px;
        }
        @media (min-width: 992px) and (max-width: 1199px) {
          width: 150px;
        }
        @media (min-width: 1200px) and (max-width: 1365px) {
          width: 170px;
        }
      }
    }
  }
  .admin-checkbox-style {
    width: calc(50% - 35px);
    max-width: 275px;
  }
  .checkbox-style {
    label {
      display: inline-block !important;
      width: 100% !important;
    }
  }
`;
const ContentWrapper = styled.div`
  width: 100%;
  padding: 15px 0;
`;
const GridWrapper = styled.div`
  margin-bottom: 10px;
`;

const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 15px 1px 15px 5px;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  border-bottom: 1px solid #eaecf0;
  .btn-action {
    display: flex;
    align-items: center;
    gap: 15px;
  }
`;
const StyledPageMainLabel = styled(PageMainLabel)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 500px; /* Adjust this value based on your needs */
  min-width: 500px; /* Adjust this value based on your needs */
`;

const StyledHeadingWrapper = styled(HeadingWrapper)`
  .k-breadcrumb {
    .k-breadcrumb-last-item {
      .k-breadcrumb-link {
        padding: 0 1px 0 3px;
      }
    }
  }
`;
